import { render, staticRenderFns } from "./Game5-1.vue?vue&type=template&id=5352296e&scoped=true&"
import script from "./Game5-1.vue?vue&type=script&lang=js&"
export * from "./Game5-1.vue?vue&type=script&lang=js&"
import style0 from "./Game5-1.vue?vue&type=style&index=0&id=5352296e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5352296e",
  null
  
)

export default component.exports